import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getOtherIssues } from 'services/glass-management/glassManagement';

export const fetchOtherIssues = createAsyncThunk('glass/other-issues/fetch', async (filters) => {
    const res = await getOtherIssues(filters.start, filters.end);
    return { data: res };
});

export const otherIssuesSlice = createSlice({
    name: 'otherIssuesBit',
    initialState: {
        data: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(fetchOtherIssues.pending, state => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOtherIssues.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(fetchOtherIssues.rejected, (state, action) => {
                state.loading = false;
                state.error = action?.error?.message ?? 'Failed to load other issues!';
                state.data = null;
            });
    }
});

export default otherIssuesSlice.reducer;
